import { Routes } from '@angular/router';

//Route for content layout with sidebar, navbar and footer.

export const Full_ROUTES: Routes = [
    {
        path: 'dashboard',
        loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule)
    },
    {
        path: 'app-alerts',
        loadChildren: () => import('../../app-alerts/app-alerts.module').then(m => m.AppAlertsModule)
    },
    {
        path: 'app-incidents',
        loadChildren: () => import('../../app-incidents/app-incidents').then(m => m.AppIncidentsModule)
    },
    {
        path: 'app-surveys',
        loadChildren: () => import('../../surveys/app-surveys.module').then(m => m.AppSurveysModule)
    },
    {
        path: 'admin-users',
        loadChildren: () => import('../../admin-users/admin-users.module').then(m => m.AdminUsersModule)
    },
    {
        path: 'documents',
        loadChildren: () => import('../../documents/documents.module').then(m => m.DocumentsModule)
    },
    {
        path: 'streets',
        loadChildren: () => import('../../streets/streets.module').then(m => m.StreetsModule)
    },
    {
        path: 'houses',
        loadChildren: () => import('../../houses/houses.module').then(m => m.HousesModule)
    },
    {
        path: 'access-log',
        loadChildren: () => import('../../access-log/access-log.module').then(m => m.AccessLogModule)
    },
    {
        path: 'booking',
        loadChildren: () => import('../../booking/booking.module').then(m => m.BookingModule)
    },
    {
        path: 'financial-admin',
        loadChildren: () => import('../../financial-admin/financial-admin.module').then(m => m.FinancialAdminModule)
    },

    {
        path: 'components',
        loadChildren: () => import('../../components/components.module').then(m => m.ComponentsModule)
    },

    {
        path: 'forms',
        loadChildren: () => import('../../forms/forms.module').then(m => m.FormsModule)
    },

    {
        path: 'tables',
        loadChildren: () => import('../../tables/tables.module').then(m => m.TablesModule)
    },

    {
        path: 'widgets',
        loadChildren: () => import('../../widgets/widgets.module').then(m => m.WidgetsModule)
    },

    {
        path: 'charts',
        loadChildren: () => import('../../charts/charts.module').then(m => m.ChartsModule)
    },

    {
        path: 'faq',
        loadChildren: () => import('../../faq/faq.module').then(m => m.FaqModule)
    },
    {
        path: 'profile',
        loadChildren: () => import('../../profile/profile.module').then(m => m.ProfileModule)
    },
    {
        path: 'pricing',
        loadChildren: () => import('../../pricing/pricing.module').then(m => m.PricingModule)
    },

    {
        path: 'downloads',
        loadChildren: () => import('../../downloads/downloads.module').then(m => m.DownloadsModule)
    }

];